// 더미데이터 복구 시: AURA_PORTFOLIO_ITEMS import 과 animationVariants의 sectionStagger 를
// 다시 추가하고 아래 주석 블록을 해제하세요.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../../styles/PortfolioSection.css';
// import { AURA_PORTFOLIO_ITEMS } from '../../data/auraPortfolioItems';
import { WORK_ITEMS } from '../../data/workItems';
import WorkDetailModal from './WorkDetailModal';
import {
  fadeUpItem,
  revealViewport,
  sectionStagger,
} from '../animations/animationVariants';

// 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
// const PREVIEW_COUNT = 3;

const PortfolioSection = () => {
  const navigate = useNavigate();
  // 상세 모달로 열어 볼 Work 항목 (null 이면 닫힘)
  const [activeWork, setActiveWork] = useState(null);

  const handleClick = () => {
    navigate('/work');
  };

  // 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
  // const openWork = (id) => {
  //   navigate(`/work/${id}`);
  // };

  // const preview = AURA_PORTFOLIO_ITEMS.slice(0, PREVIEW_COUNT);

  return (
    <section className="portfolio-section portfolio-section--article-preview">
      <motion.span
        className="section-eyebrow"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        03 / Work
      </motion.span>
      <motion.h2
        className="portfolio-title"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Work<em className="portfolio-title-dot">.</em>
      </motion.h2>
      <motion.p
        className="portfolio-section-lead"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Aura로 구축·운영한 프로젝트와 현장의 반응을 모았습니다. 카드를 눌러 상세 기록을 확인해 보세요.
      </motion.p>

      {/* 더미데이터 임시 비공개 (준비중) — 추후 복구 예정
      <motion.ul
        className="portfolio-home-list portfolio-home-list--horizontal"
        variants={sectionStagger}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        {preview.map((item) => (
          <motion.li key={item.id} variants={fadeUpItem}>
            <button
              type="button"
              className="portfolio-home-row portfolio-home-row--horizontal"
              onClick={() => openWork(item.id)}
            >
              <div className="portfolio-home-row__thumb">
                <img src={item.image} alt="" loading="lazy" />
              </div>
              <div className="portfolio-home-row__text">
                <div className="portfolio-home-row__meta">
                  <span
                    className={
                      item.kind === 'review'
                        ? 'portfolio-home-tag portfolio-home-tag--review'
                        : 'portfolio-home-tag'
                    }
                  >
                    {item.tag}
                  </span>
                  <time className="portfolio-home-date">{item.date}</time>
                </div>
                <span className="portfolio-home-title">{item.title}</span>
              </div>
              <span className="portfolio-home-row__arrow" aria-hidden="true">→</span>
            </button>
          </motion.li>
        ))}
      </motion.ul>
      */}

      {/* 실제 진행한 프로젝트·전시 미리보기 — 클릭 시 상세 모달 표시 */}
      <motion.ul
        className="portfolio-home-list portfolio-home-list--horizontal"
        variants={sectionStagger}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        {WORK_ITEMS.map((item) => (
          <motion.li key={item.id} variants={fadeUpItem}>
            <button
              type="button"
              className="portfolio-home-row portfolio-home-row--horizontal"
              onClick={() => setActiveWork(item)}
            >
              <div className="portfolio-home-row__thumb">
                <img src={item.image} alt="" loading="lazy" />
              </div>
              <div className="portfolio-home-row__text">
                <div className="portfolio-home-row__meta">
                  <span
                    className={
                      item.kind === 'review'
                        ? 'portfolio-home-tag portfolio-home-tag--review'
                        : 'portfolio-home-tag'
                    }
                  >
                    {item.tag}
                  </span>
                  <time className="portfolio-home-date">{item.date}</time>
                </div>
                <span className="portfolio-home-title">{item.title}</span>
              </div>
              <span className="portfolio-home-row__arrow" aria-hidden="true">→</span>
            </button>
          </motion.li>
        ))}
      </motion.ul>

      <motion.div
        className="portfolio-home-coming-soon"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        <span className="portfolio-home-coming-soon__eyebrow">Coming Soon</span>
        <p className="portfolio-home-coming-soon__title">
          새로운 작업물을 준비하고 있어요
        </p>
        <p className="portfolio-home-coming-soon__text">
          Aura와 함께한 프로젝트와 현장의 이야기를 곧 이곳에서 만나보실 수 있습니다.
        </p>
      </motion.div>

      <motion.button
        type="button"
        className="portfolio-button"
        onClick={handleClick}
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Work 전체 보기<span className="btn-arrow" aria-hidden="true">→</span>
      </motion.button>

      <WorkDetailModal item={activeWork} onClose={() => setActiveWork(null)} />
    </section>
  );
};

export default PortfolioSection;
